import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table,
	Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery';
import AcademicPage from '../../views/AcademicPage/';
const GLOBAL = require('../../Globals');

class Abservation extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			acyear: '',
			cls: '',
			section: '',
			examname: '',
			subject: '',
			_message: '',
			alertClass: '',
			_redirect: false,
			posts: [],
			sections: [],
			sec: [],
			accyear: [],
			exams: [],
			subj: [],
			modal: false,
			modal1: false,
			modal2: false,
			modal3: false,
			timetab: [],
			data: [],
			marks: [],
			markdata: [],
			stud: [],
			marktotal: [],
			abserve: [],
			allocateClass: [],
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.toggle = this.toggle.bind(this);
		this.onClassChange = this.onClassChange.bind(this);
		this.onReMarkUpdate = this.onReMarkUpdate.bind(this);
	}
	
	onClassChange(e){
		this.state.cls = e.target.value;
		this.getsection();
	}

	toggle() {
		this.setState({
			modal: !this.state.modal
		});
	}

	/** set value **/
	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
		this.getexam();
		this.getsubject();
		this.getdata();
		this.getmark();
		this.getstudent();
		this.getabserve();
	}

	handleChange(id, e) {

		this.state.regno = id;
		this.state.remarks = e.target.id;
		this.setState({
			modal: !this.state.modal
		});
	}

	onRemarkChange(id, e) {

		var index = this.state.marks.findIndex(function (obj) {

			return (obj.id == id);
		});

		if (index === -1) {

			this.state.marks.push({ "id": id, "remarks": e.target.value });
		}
		else {

			this.state.marks[index].remarks = e.target.value;
		}
	}

	onReMarkUpdate(e) {

		// e.preventDefault();
		$("#showLoader").show();
		PostData('exam/editabserve', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson.status == '1') {
				this.getabserve();
				this.toggle();
			}
			else {

				this.setState({
					_message: 'Invalid Key',
					alertClass: 'alert alert-danger'
				});
			}
		});
	}

	onSubmit(e) {
		e.preventDefault();
		$("#showLoader").show();
		PostData('exam/addabservation', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson.status == '1') {
				this.setState({
					_message: 'Abservation Added Successfully!..',
					alertClass: 'alert alert-success',
				});
				this.setState({ marks: '' });
				$("#abserve").hide();
				document.getElementById("abform").reset();
			}
			else {

				this.setState({
					_message: 'Invalid Key',
					alertClass: 'alert alert-danger'
				});
			}
		});
	}

	onUpdate() {
		$("#showLoader").show();
		PostData('exam/editpassmark', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson.status == '1') {
				this.toggle();
				this.setState({
					_message: 'Time Table Updated Successfully!..',
					alertClass: 'alert alert-success',
				});
				this.setState({ subject: '', passmark: '' });
				this.getdata();
			}
			else {
				this.toggle();
				this.setState({
					_message: 'Invalid Key',
					alertClass: 'alert alert-danger'
				});
			}
		});

	}

	componentWillMount() {

		this.getacyear();
		this.getclass();
	}

	/** get Academic Year **/
	getacyear() {
		$("#showLoader").show();
		GetData('academic/getacyear').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
				
				let userData = JSON.parse(sessionStorage.getItem('userData'));
				this.state.userId = userData['userid'];
				this.state.userRole = userData['userrole'];
				this.state.staffid = userData['staffid'];
				
				if(userData['userrole'] == 'classteacher'){
					this.checkclassteacher();
				}
				this.getallocatesection();
			}
		});
	}
	
	checkclassteacher(){
		$("#showLoader").show();
		GetData('employee/checkclassteacher/'+this.state.acyear+'/'+this.state.staffid).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					allocateClass : responseJson
				});
			}
			$("#showLoader").hide();
		});
	}

	getclass() {
		$("#showLoader").show();
		GetData('classs/getclass').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson
				});
			}
		});
	}
	
	getallocatesection(){

		GetData('section/getsecbyacyear/'+this.state.acyear).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					sections : responseJson
				});
			}
		});
	}
	
	getsection(){
		var dat = [];
		if(this.state.cls!=''){
			for(var i=0;i<this.state.sections.length;i++)	{

				if(this.state.sections[i].clas == this.state.cls){
					dat.push(this.state.sections[i]);
				}
			}
		}
		this.setState({sec : dat});
	}

	getexam() {

		var ac = $("#year").val();
		$("#showLoader").show();
		GetData('exam/getexambyacyear/' + ac).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.state.marktotal = [];
				this.setState({
					exams: responseJson
				});
				this.state.marktotal = new Array(this.state.exams.length);
			}
		});
	}

	getsubject() {

		var ac = $("#year").val();
		var cls = $("#clas").val();
		$("#showLoader").show();
		GetData('assignsubject/getmainsubbycls/' + ac + '/' + cls).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					subj: responseJson
				});
			}
		});
	}

	getstudent() {

		var ac = $("#year").val();
		var cls = $("#clas").val();
		var sec = $("#secs").val();
		$("#showLoader").show();
		GetData('student/getstdbysecandcls/' + ac + '/' + cls + '/' + sec).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					stud: responseJson
				});
			}
		});
	}

	getdata() {

		var ac = $("#year").val();
		var cls = $("#clas").val();
		var sec = $("#secs").val();
		$("#showLoader").show();
		GetData('student/getstddetails/' + ac + '/' + cls + '/' + sec).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					data: responseJson
				});
			}
		});
	}

	// Get Subject By Class
	getsubjectbycls() {

		var subj = [];

		for (var i = 0; i < this.state.subj.length; i++) {
			subj.push(<th>{this.state.subj[i].sub}</th>);
		}
		return subj;
	}

	getmark() {

		var ac = $("#year").val();
		var cls = $("#clas").val();
		var sec = $("#secs").val();
		var exam = $("#exam").val();
		$("#showLoader").show();
		GetData('exam/getmarkbyabserve/' + ac + '/' + cls + '/' + sec + '/' + exam).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					markdata: responseJson
				});
			}
		});
	}

	getabserve() {

		var ac = $("#year").val();
		var cls = $("#clas").val();
		var sec = $("#secs").val();
		var exam = $("#exam").val();
		$("#showLoader").show();
		GetData('exam/getabservation/' + ac + '/' + cls + '/' + sec + '/' + exam).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					abserve: responseJson
				});
			}
		});
	}

	getmarkbystd(regno, index) {

		var mar = [];
		var tot = 0;
		var total = 0;
		for (var j = 0; j < this.state.subj.length; j++) {

			if (this.checkmarks(regno, this.state.subj[j].subject) != false) {

				mar.push(<td>{parseFloat(this.checkmarks(regno, this.state.subj[j].subject)) == '-1' ? 'AB' : parseFloat(this.checkmarks(regno, this.state.subj[j].subject))}</td>);
				total += parseFloat(this.checkmaxmarks(regno, this.state.subj[j].subject));
				if( parseFloat(this.checkmarks(regno, this.state.subj[j].subject))!='-1'){
					tot += parseFloat(this.checkmarks(regno, this.state.subj[j].subject));
				}
				this.state.marktotal[index] = tot + '/' + total;
			}
			else {

				mar.push(<td></td>);
			}
		}

		return mar;
	}

	checkmarks(regno, sub) {

		var bstate = false;

		for (var ii = 0; ii < this.state.markdata.length; ii++) {

			if (this.state.markdata[ii].subject == sub && this.state.markdata[ii].studentid == regno) {

				bstate = this.state.markdata[ii].mark;
				break;
			}
			else {

				bstate = false;
			}
		}

		return bstate;

	}

	checkmaxmarks(regno, sub) {

		var bstate = false;

		for (var jj = 0; jj < this.state.markdata.length; jj++) {

			if (this.state.markdata[jj].subject == sub && this.state.markdata[jj].studentid == regno) {

				bstate = this.state.markdata[jj].maxmark;
				break;
			}
			else {

				bstate = false;
			}
		}

		return bstate;

	}

	getremarks(regno) {

		var rem = [];

		if (this.checkabserve(regno) === false) {

			rem.push(<td><Input type="textarea" onChange={this.onRemarkChange.bind(this, regno)} /></td>);
		}
		else {

			rem.push(<td><Button size="sm" color="primary" id={this.checkabserve(regno)} onClick={this.handleChange.bind(this, regno)}>{this.checkabserve(regno)}</Button></td>);
		}

		return rem;
	}

	checkabserve(regno) {

		var boolstate = false;

		for (var i = 0; i < this.state.abserve.length; i++) {

			if (this.state.abserve[i].regno == regno) {

				boolstate = this.state.abserve[i].remarks;
				break;
			}
			else {

				boolstate = false;
			}
		}

		return boolstate;
	}
	
	checkClass(cls){
		var bstate = false;
		var d = this.state.allocateClass;
		var index = d.findIndex(function(obj){
			return(obj.class == cls);
		});
		if(index > -1){
			bstate = true;
		}
		return bstate;
	}
	
	checkSection(sec){
		var bstate = false;
		var d = this.state.allocateClass;
		var index = d.findIndex(function(obj){
			return(obj.section == sec);
		});
		if(index > -1){
			bstate = true;
		}
		return bstate;
	}
	
	render() {

		if (this.state._redirect) {

			return (<Redirect to={'/subject/subjectupdate/' + this.state.idd} />);

		}

		var exa = this.state.exams;
		var items = this.state.posts;
		var acyear = this.state.accyear;
		var sub = this.state.subj;
		var secs = this.state.sec;

		if (this.state.acyear != '' && this.state.cls != '' && this.state.section != '' && this.state.examname != '') {

			$("#abserve").show();
		}
		else {

			$("#abserve").hide();
		}

		return (
			<div>
				<AcademicPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<form action="" method="post" role="form" id="abform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<Row>
							<Col md="12">
								<Card>
									<CardHeader>
										<strong>Class Teacher Observation</strong>
										<Row>
											<Col md={3} sm={12} xs={12}>
												<label>Academic Year</label>
												<select name="acyear" onChange={this.onChange} className="form-control" required id="year">
													<option value="">Select Academic Year</option>
													{
														acyear.map(function (item) {
															return <option value={item.id}>{item.value}</option>;
														})
													}
												</select>
											</Col>
											<Col md={3} sm={12} xs={12}>
												<label>Class</label>
												<select name="cls" onChange={this.onClassChange} className="form-control" required id="clas">
													<option value="">Select Class</option>
													{(this.state.userRole == 'classteacher') ?
														items.map((item)=>{
															if(this.checkClass(item.id)){
																return <option value={item.id}>{item.class}</option>;
															}
														})
														:
														items.map(function (item) {
															return <option value={item.id}>{item.class}</option>;
														})
													}
												</select>
											</Col>
											<Col md={3} sm={12} xs={12}>
												<label>Section</label>
												<select name="section" onChange={this.onChange} className="form-control" required id="secs">
													<option value="">Select Section</option>
													{(this.state.userRole == 'classteacher') ?
														secs.map((item)=>{
															if(this.checkSection(item.section)){
																return <option value={item.section}>{item.secs}</option>;
															}
														})
														:
														secs.map(function (item) {
															return <option value={item.section}>{item.secs}</option>;
														})
													}
												</select>
											</Col>
											<Col md={3} sm={12} xs={12}>
												<label>Exam</label>
												<select name="examname" onChange={this.onChange} className="form-control" required id="exam">
													<option value="">Select Exam</option>
													{
														exa.map(function (item) {
															return <option value={item.id}>{item.exam}</option>;
														})
													}
												</select>
											</Col>
										</Row>
									</CardHeader>
									<CardBody>
										<Row id="abserve">
											<Col md="12">
												<Table responsive bordered>
													<thead>
														<tr>
															<th>S.No</th>
															<th>Reg No</th>
															<th>Student Name</th>
															{this.getsubjectbycls()}
															<th>Total</th>
															<th>Remarks</th>
														</tr>
													</thead>
													<tbody>
														{this.state.stud.map((item, index) =>

															<tr key={item}>
																<td>{index + 1}</td>
																<td>{item.regno}</td>
																<td>{item.stdname}</td>
																{this.getmarkbystd(item.regno, index)}
																<td>{this.state.marktotal[index]}</td>
																{this.getremarks(item.regno)}
															</tr>
														)}
													</tbody>
												</Table>
												<Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
													<ModalHeader toggle={this.toggle}>Edit Remarks</ModalHeader>
													<ModalBody>
														<Row>
															<Col md="12">
																<FormGroup>
																	<Label htmlFor="name">Remark </Label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
										<Input type="textarea" name="remarks" value={this.state.remarks} onChange={this.onChange} />
																</FormGroup>
															</Col>
														</Row>
													</ModalBody>
													<ModalFooter>
														<Button type="submit" color="primary" onClick={this.onReMarkUpdate}>Submit</Button>
														<Button color="secondary" onClick={this.toggle}>Cancel</Button>
													</ModalFooter>
												</Modal>
											</Col>
										</Row>
									</CardBody>
									<CardFooter>
										<Button type="submit" size="sm" className="btn-right" color="primary"><i className="fa fa-dot-circle-o"></i> Save</Button>
									</CardFooter>
								</Card>
							</Col>
						</Row>
					</form>
				</div>
			</div>
		)
	}
}

export default Abservation;


// WEBPACK FOOTER //
// ./src/exams/Abservation/Abservation.js